import { DEFAULT_IMAGE_QUALITY } from '../constants';

export function imageQualityFilter(image, args) {
    const quality = _.get(args, 'quality', DEFAULT_IMAGE_QUALITY);
    const src = `${image.fields.file.url}?w=${image.fields.file.details.image.width}&q=${quality}`;

    return src;
}

export default imageQualityFilter;
